/**
 * @packageDocumentation
 * @module Object
 */
import { convertBracketNotationToDots } from './convertBracketNotationToDots';
/**
 * Function that peceives the path as a string and generates an array of paths out of it. This output could be an empty array if the input string is empty.
 *
 * @param {string | string[]} path
 *
 * @return {any}
 */
export var convertDotNotationToArrayOfPath = function (path) { return (path === '' ? [] : convertBracketNotationToDots(path).split('.')); };
//# sourceMappingURL=convertDotNotationToArrayOfPath.js.map